import type { PrescriptionT } from '@lotushealth/lotushealth_js_sdk/schemas';

export type PrescriptionFieldKey = keyof PrescriptionT;

/**
 * Single source of truth for human-readable ``PrescriptionT`` field
 * labels. Tables, detail cards, search hits, and any future surface
 * should look up labels here rather than inline their own.
 */
export const PRESCRIPTION_FIELD_LABELS: Readonly<Partial<Record<PrescriptionFieldKey, string>>> = {
  DisplayName: 'Prescription',
  Status: 'Status',
  MedicationStatus: 'Medication status',
  Quantity: 'Quantity',
  Refills: 'Refills',
  DaysSupply: 'Days supply',
  Directions: 'Directions',
  PharmacyId: 'Pharmacy',
  EffectiveDate: 'Effective date',
  WrittenDate: 'Written date',
};

/** Resolve a field's label, falling back to the field key itself. */
export function prescriptionFieldLabel(key: PrescriptionFieldKey): string {
  return PRESCRIPTION_FIELD_LABELS[key] ?? String(key);
}
